module.exports = __webpack_public_path__ + "img/circle-coaster.2073adc0.svg";